import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// Check if the page was pre-rendered by react-snap
if (container.hasChildNodes()) {
  // Hydrate the pre-rendered HTML
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Normal client-side render for development
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
